import { EventEmitter } from 'events';
import { CategoryType } from 'types';
import Dispatcher from 'core/Dispatcher';
import Actions from 'constants/Actions';
import ParametersStore from 'stores/ParametersStore';

var categoriesConfig = require('../../configs/categories.config.json');

const CHANGE_EVENT = 'change';

/**
 * Коллекция категорий перевозок.
 * @type {Object.<number, CategoryType}
 */
const _allCategories = Object.values(categoriesConfig).reduce((result, category) => {
    var parameters = category.params.reduce((result, id) => {
        var param = ParametersStore.getParameterById(id);
        result[param.name] = param;
        return result;
    }, {});

    result[category.name] = new CategoryType({
        intId: category.id,
        id: category.name,
        name: category.name,
        title: category.title,
        parameters: parameters,
    });

    return result;
}, {});

var _selectedCategory = null;

/**
 * Выбирает категорию доставки.
 * @param {number} categoryId
 */
function selectCategory(categoryId) {
    _selectedCategory = _allCategories[categoryId];
}

/**
 * Снимает выбор категории.
 */
function deselectCategory() {
    _selectedCategory = null;
}

class CategoryStore extends EventEmitter {

    getAllCategories() {
        return _allCategories;
    }

    getSelected() {
        return _selectedCategory;
    }

    getNormalizedState() {
        return _selectedCategory ? _selectedCategory.intId : 1;
    }
    
    denormalizeState(normalizedState) {
        if (normalizedState.category_id) {
            var categoryName = Object.keys(_allCategories).find(categoryName => {
                return _allCategories[categoryName].intId == normalizedState.category_id;
            });
            
            if (categoryName) {
                selectCategory(_allCategories[categoryName].id);
            }
        }
    }

    validate() {
        return Promise.resolve();
    }

    /**
     * @param {function} callback
     */
    addChangeListener(callback) {
        this.on(CHANGE_EVENT, callback);
    }

    /**
     * @param {function} callback
     */
    removeChangeListener(callback) {
        this.removeListener(CHANGE_EVENT, callback);
    }

    emitChange() {
        this.emit(CHANGE_EVENT);
    }

    resetSelectedCategory() {
        _selectedCategory = null;
    }

    dispatchToken = Dispatcher.register((action) => {
        const payload = action.payload;

        switch (action.type) {
            case Actions.SELECT_CATEGORY:
                if (!_selectedCategory) {
                    selectCategory(payload.categoryId);
                }
                break;

            case Actions.DESELECT_CATEGORY:
                deselectCategory();
                break;

            default:
                return;
        }

        this.emitChange();
    })

}

export default new CategoryStore();



// WEBPACK FOOTER //
// ./client/stores/CategoryStore.js